(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-main.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-main.js');

'use strict';

const {
  useEffect
} = React;
const {
  BankIdStart
} = svs.iam_idp.components.bank_id;
const {
  PollingMobile,
  PollingDesktop,
  Loading
} = svs.iam_idp.components.shared;
const {
  useAtomValue
} = jotai;
const {
  isPollingAtom,
  showLoaderAtom,
  loginCompletedAtom,
  activeMethodAtom
} = svs.iam_idp.atoms;
const login = svs.iam_idp.utils.Login;
const BankIdMain = _ref => {
  let {
    showQR
  } = _ref;
  const activeMethod = useAtomValue(activeMethodAtom);
  const isPolling = useAtomValue(isPollingAtom);
  const showLoader = useAtomValue(showLoaderAtom);
  const loginCompleted = useAtomValue(loginCompletedAtom);
  const PollingComponent = showQR ? PollingDesktop : PollingMobile;
  useEffect(() => {
    if (showQR && !loginCompleted) {
      login.start(activeMethod.isFreja, false);
    }
  }, [activeMethod.isFreja, showQR, loginCompleted]);
  if (loginCompleted) {
    return React.createElement(Loading, null);
  }
  if (showQR && isPolling && showLoader) {
    return React.createElement(PollingDesktop, null);
  }
  return (isPolling || showLoader) && !showQR ? React.createElement(PollingComponent, null) : React.createElement(BankIdStart, {
    isNewCustomer: false,
    showQR: showQR
  });
};
svs.iam_idp.components.bank_id.BankIdMain = BankIdMain;

 })(window);